export default __webpack_public_path__ + "static/img24h-ff2bfea203231c25edec31b5641883b7.jpg";